import { useForm } from '@/common/form/FormContext';
import { useEffect } from 'react';

export const TierCode = ({ tierObj }) => {
  const { formValues, assignValue } = useForm();

  useEffect(() => {
    assignValue('code', tierObj.code + '_' + formValues.tier);
  }, [formValues.tier]);

  return null;
};
